import app from '../app';
import collectionsMain from './collections/collections-main';

app.add({
  collectionsMain,
});
app.mount();
